export default __webpack_public_path__ + "static/media/top_btn.7937a42c.svg";